/****** Created by shivani gajjar(shivani.gajjar@kahunasystems.com) 4/10/17 3:47 PM*******/
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CommonCookieService } from 'kscookies';

@Injectable()
export class LanguageService {

  constructor(public translate: TranslateService, private cookieService: CommonCookieService) {
  }

  getLanguages() {
    return this.translate.getLangs();
  }

  getLangs() {
    return this.translate.getLangs();
  }

  addLanguages(lang: string[]) {
    this.translate.addLangs(lang);
  }

  setDefaultLanguage(lang) {
    if (!lang || lang === 'undefined' || lang === 'null') {
      console.warn('[LanguageService] setDefaultLanguage received null/undefined:', lang, '-> Defaulting to: en');
    }
    const validLang = (lang && lang !== 'undefined' && lang !== 'null') ? lang : 'en';
    this.translate.setDefaultLang(validLang);
    this.translate.use(validLang);
    this.cookieService.setCookie('lang', validLang);
  }

  setDefaultLang(lang) {
    if (!lang || lang === 'undefined' || lang === 'null') {
      console.warn('[LanguageService] setDefaultLang received null/undefined:', lang, '-> Defaulting to: en');
    }
    const validLang = (lang && lang !== 'undefined' && lang !== 'null') ? lang : 'en';
    this.translate.setDefaultLang(validLang);
    this.translate.use(validLang);
    this.cookieService.setCookie('lang', validLang);
  }

  getCurrentLanguage() {
    const lang = this.cookieService.getCookie('lang');
    if (lang && lang !== 'undefined' && lang !== 'null') {
      return lang;
    }
    const fallback = this.translate.currentLang || this.translate.defaultLang || 'en';
    console.warn('[LanguageService] getCurrentLanguage cookie is null/undefined (', lang, '), using fallback:', fallback);
    return fallback;
  }

  getDefaultLang() {
    const lang = this.cookieService.getCookie('lang');
    if (lang && lang !== 'undefined' && lang !== 'null') {
      return lang;
    }
    const fallback = this.translate.defaultLang || this.translate.currentLang || 'en';
    console.warn('[LanguageService] getDefaultLang cookie is null/undefined (', lang, '), using fallback:', fallback);
    return fallback;
  }

  changeLanguage(lang) {
    this.translate.use(lang);
  }

  instant(key: string) {
    return this.translate.instant(key);
  }

}
